import { Timestamp } from "firebase/firestore";

// Handler de fallback para datas zoadas (DD/MM/YYYY => YYYY-MM-DD)
const forceISODate = (dateVal) => {
    if (!dateVal) return null;
    if (dateVal instanceof Date) return dateVal.toISOString().split('T')[0];
    if (typeof dateVal === 'string') {
        if (dateVal.includes('/')) {
            const [datePart] = dateVal.split(' ');
            const parts = datePart.split('/');
            if (parts.length === 3) {
                const [day, month, year] = parts;
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            }
        }
        return dateVal.substring(0, 10);
    }
    return null;
};

export const saleToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const payload = {
        idTenant,

        // Contexto Operacional (Membro)
        idMember: data.idMember,  // Firestore doc.id do membro
        memberNumber: data.memberNumber,
        memberName: data.memberName,
        memberPhone: data.memberPhone,
        memberEmail: data.memberEmail,
        memberPhotoUrl: data.memberPhotoUrl,
        
        // Contexto Operacional (Funcionários / Consultor)
        idEmployee: data.idEmployee,
        employeeName: data.employeeName,
        employeeEmail: data.employeeEmail,
        employeePhone: data.employeePhone,
        employeePhotoUrl: data.employeePhotoUrl,
        
        idConsultant: data.idConsultant,
        consultantName: data.consultantName,
        consultantEmail: data.consultantEmail,
        consultantPhone: data.consultantPhone,
        consultantPhotoUrl: data.consultantPhotoUrl,
        
        idCashierShift: data.idCashierShift, // <--- adicionado para atrelar venda ao caixa

        date: forceISODate(data.date),

        // Carrinho e Vendas
        items: data.items || [],

        // Finanças e Consolidação
        subtotal: Number(data.subtotal),
        discountTotal: Number(data.discountTotal),
        totalAmount: Number(data.totalAmount),
        totalPaid: Number(data.totalPaid),
        balance: Number(data.balance),
        surplus: Number(data.surplus),

        // Fluxo de Caixa Pagamento
        paymentMethods: data.paymentMethods || [],

        // Data de vencimento do saldo restante
        dueDateBalance: data.dueDateBalance,

        // Gamificação e Cupons
        couponCode: data.couponCode,
        couponDiscountValue: Number(data.couponDiscountValue),

        // Status
        status: data.status,
        notes: data.notes,

        // Tracking & Ciclo de Vida
        saleCategory: data.saleCategory || (data.id ? undefined : "NEW"), // NEW, RENEWAL, UPGRADE
        idExperimentalTrigger: data.idExperimentalTrigger || null,

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? (data.createdBy || null) : {
            uid: authUser?.uid || "system",
            name: authUser?.name || authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.name || authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

export const saleFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    // Normalização das chaves para que a Interface (Frontend/Recibo) 
    // receba independentemente de como foi batizado no Banco de Dados
    return {
        id: snapshot.id,
        ...data,
        saleNumber: data.saleNumber || snapshot.id.substring(0, 8).toUpperCase(),
        totalAmount: Number(data.totalAmount),
        discountTotal: Number(data.discountTotal),
        payments: data.paymentMethods || [],
        balance: Number(data.balance),
        saleCategory: data.saleCategory || "NEW",
        idExperimentalTrigger: data.idExperimentalTrigger || null,
        date: data.date?.toDate ? data.date.toDate().toISOString().split('T')[0] : data.date,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
